import React, { useMemo } from 'react';
import { LookupSelect, type LookupSelectProps } from './LookupSelect';
import { labelVessel } from './lookupHelpers';
import { compareByVesselName, useEndpointLookupOptions } from './useLookupOptions';

const ENDPOINT = '/vessels?page=1&limit=2000';

function keepIdsKey(includeIds: LookupSelectProps['includeIds']): string {
  return (includeIds ?? [])
    .map((id: string | number | null | undefined) => (id == null || id === '' ? '' : String(id)))
    .filter(Boolean)
    .join(',');
}

/** Active vessels, ordered by vessel name. */
export function VesselSelect({ includeIds, ...props }: LookupSelectProps) {
  const keepKey = keepIdsKey(includeIds);
  const keepIds = useMemo(() => (keepKey ? keepKey.split(',') : undefined), [keepKey]);
  const { options, isLoading } = useEndpointLookupOptions({
    endpoint: ENDPOINT,
    getLabel: labelVessel,
    keepIds,
    compare: compareByVesselName,
  });
  return (
    <LookupSelect
      {...props}
      includeIds={includeIds}
      options={options}
      isLoading={isLoading}
      placeholder={props.placeholder ?? 'Select vessel…'}
      searchPlaceholder={props.searchPlaceholder ?? 'Search vessels…'}
    />
  );
}

export default VesselSelect;
